import AppConstants from '../constants/AppConstants';
import FormattedShiftNR from '../models/FormattedShiftNR';
import { AxiosShiftNRClient } from '../proxy/ProxyClients';

const ShiftNRService = {
  getAllShifts: (companyId: number, startDate: string, endDate: string): Promise<Array<FormattedShiftNR>> =>
    AxiosShiftNRClient.page(
      {
        pageNumber: 1,
        pageSize: AppConstants.MAX_PAGE_SIZE,
        dateTimeInterval: {
          startTimeUtc: startDate,
          endTimeUtc: endDate,
        },
      }
    ).then((resp) => (resp?.items?.map((shift: any) => new FormattedShiftNR(shift)) || [])),

  getShiftById: (id: number, companyId: number): Promise<FormattedShiftNR> => AxiosShiftNRClient.get(id)
    .then((resp) => new FormattedShiftNR(resp)),

  deleteShiftById: (id: number) => AxiosShiftNRClient.delete([id]),

  updateRemarks: (id: number, remark: string = ''): Promise<FormattedShiftNR> => AxiosShiftNRClient.updateRemark({
    id,
    remark
  }).then((resp) => new FormattedShiftNR(resp)),
  downloadLinfoxTimesheets: (startDate: string, endDate: string) => {
    const payload = {
      pageNumber: 1,
      pageSize: AppConstants.MAX_PAGE_SIZE,
      dateTimeInterval: {
        startTimeUtc: startDate,
        endTimeUtc: endDate
      }
    };

    return AxiosShiftNRClient.download(payload);
  },

  acknowledgeWarning: (shiftNrId: number, shiftNRWarningId: number) =>
    AxiosShiftNRClient.acknowledgeWarning({
      shiftNrId,
      shiftNRWarningId
    }),
};

export default ShiftNRService;
